export const addToDataLayer = (payload: any) => {
  // @ts-ignore
  const dataLayer = window.dataLayer || [];
  dataLayer.push({ ...payload });
  // @ts-ignore
  window.dataLayer = dataLayer;
};
